<script setup lang="ts">
import CandidateDetailHeader from '@/features/candidates/components/CandidateDetailHeader.vue'
import { useGetAdminMatchingCandidate } from '@swipe4work/api-orval'
import { type GetAdminMatchingCandidateCandidateProfileDto } from '@swipe4work/models-orval'
import { useTopBarTitle } from '@/shared/composables/UseTopBarTitle'

definePage({
  path: '/matching/candidates/:userId',
  name: '/matching/CandidateDetail',
  meta: {
    title: 'Kandidaat',
    breadcrumbParent: '/matching/Candidates',
    permission: {
      resource: 'Candidates',
      level: 'Read',
    },
  },
})

const route = useRoute('/matching/CandidateDetail')
const router = useRouter()
const userId = computed(() => Number((route.params as { userId: string }).userId))

const { data, isPending } = useGetAdminMatchingCandidate(userId, { query: { staleTime: 5 * 60 * 1000 } })

const profile = computed(() => data.value?.profile ?? null)

provide<ComputedRef<GetAdminMatchingCandidateCandidateProfileDto | null>>('candidateProfile', profile)
provide<Ref<boolean>>('candidateIsPending', isPending)
provide<ComputedRef<number>>('candidateUserId', userId)

// The topbar shows the candidate's name as the last breadcrumb once loaded.
useTopBarTitle(() => profile.value ? `${profile.value.firstName} ${profile.value.lastName}`.trim() : null)

onBeforeMount(() => {
  if (route.name === '/matching/CandidateDetail') {
    router.replace({
      name: '/matching/CandidateDetail/profile' as any,
      params: { userId: userId.value },
    })
  }
})

watch(() => route.name, (name) => {
  if (name === '/matching/CandidateDetail') {
    router.replace({
      name: '/matching/CandidateDetail/profile' as any,
      params: { userId: userId.value },
    })
  }
})

const tabs = [
  {
    label: 'Profiel',
    name: '/matching/CandidateDetail/profile',
  },
  {
    label: 'Sollicitaties',
    name: '/matching/CandidateDetail/job-applications',
  },
  {
    label: 'Matchscores',
    name: '/matching/CandidateDetail/match-scores',
  },
  {
    label: 'Algoritme vergelijker',
    name: '/matching/CandidateDetail/match-score-statistics',
  },
  {
    label: 'Kandidaat statistieken',
    name: '/matching/CandidateDetail/statistics',
  },
  {
    label: 'Skill suggesties',
    name: '/matching/CandidateDetail/overview',
  },
]
</script>

<template>
  <div class="space-y-5">
    <CandidateDetailHeader :profile="profile" />

    <Tabs :value="route.name" scrollable>
      <TabList>
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="{ name: tab.name as any, params: { userId } }"
        >
          <Tab :value="tab.name">
            {{ tab.label }}
          </Tab>
        </router-link>
      </TabList>
    </Tabs>

    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>
